import { DialogContent as UIDialogContent, RaisedButton } from "@evergis/ui";
import styled from "styled-components";

export const DeleteFeatureButton = styled(RaisedButton)``;

export const DialogContent = styled(UIDialogContent)`
  align-items: center;
  padding-top: 2.5rem;
  padding-bottom: 1rem;
`;
